import {
  Component,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
} from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { Helpers } from "./helpers";
import { CookieService } from "ngx-cookie-service";
import { TimelineService } from "./_services/timeline.service";
import { WebcamInitError, WebcamImage, WebcamUtil } from "ngx-webcam";
import { Subject, Observable } from "rxjs";

@Component({
  selector: "body",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  show = "chat";
  globalBodyClass =
    "m-page--loading-non-block m-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default";
  tagArr = [];
  selectedTag: string = "Select";
  tag: string = null;
  tagevent = new EventEmitter<any>();
  listType = null;
  //properties of Timeline
  message: string = null;
  post: string = null;
  component: { header: string } = null;
  selectedFile: File = null;
  imgUrl = [];
  whitelabelFlag: boolean = false;

  // toggle webcam on/off
  cameraOnOff = "on";
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public facingMode: string = "environment";
  public errors: WebcamInitError[] = [];

  // latest snapshot
  public webcamImage: WebcamImage = null;

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();

  constructor(
    private _router: Router,
    private cookieService: CookieService,
    public service: TimelineService
  ) {
    this.service.component.subscribe((res: { header: string }) => {
      this.component = res;
    });
  }

  ngOnInit() {
    // const isConnected = navigator.onLine;
    // console.log("Is connected:", isConnected);
    // if (isConnected === true) {
    //   this._router.navigate(['Internetconnectivity']);
    // }
    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        Helpers.setLoading(true);
        Helpers.bodyClass(this.globalBodyClass);
      }
      if (route instanceof NavigationEnd) {
        Helpers.setLoading(false);
      }
    });
    this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));

    // webcam
    WebcamUtil.getAvailableVideoInputs().then(
      (mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      }
    );
  }

  onSelect(d) {
    this.show = d;
  }
  onTag(tag: string) {
    this.tagArr.push(" " + tag + " ");
    this.tag = tag;
    this.selectedTag = tag;
  }
  onlistType(data) {
    this.listType = data;
  }
  onDeleteTag(i) {
    this.tagArr.splice(i, 1);

    this.tagevent.emit(this.tagArr);
  }
  onPost(msg: string) {
    if (msg !== null && msg !== "") {
      const tag = this.tagArr;

      const d = new Date();
      //date & time format
      const date =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");

      // this.service.onPost({ message: msg, tag: tag, date: date });

      this.message = "";
      this.tag = null;
      this.tagArr = [];
    }
  }

  // Selected File
  onFileChanged(file) {
    if (file.target.files && file.target.files[0]) {
      var filesAmount = file.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();

        reader.onload = (event: any) => {
          console.log(event.target.result);
          this.imgUrl.push(event.target.result);
        };

        reader.readAsDataURL((this.selectedFile = file.target.files[i]));
      }
    }
  }

  //webcam related methods

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(s): void {
    this.cameraOnOff = s;
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    if (
      error.mediaStreamError &&
      error.mediaStreamError.name === "NotAllowedError"
    ) {
      console.warn("Camera access was not allowed by user!");
    }
    this.errors.push(error);
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.log("received webcam image", webcamImage);

    this.webcamImage = webcamImage;
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log("active device: " + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== "") {
      result.facingMode = { ideal: this.facingMode };
    }

    return result;
  }
}
